import axios from 'axios'
import configHttp from 'constants/HttpConstants'
import { interceptorRequest, interceptorRequestError, interceptorResponseSuccess, interceptorResponseError } from 'httpServices/httpServiceInterceptor.js'

const axiosInstance = axios.create(configHttp)

axiosInstance.interceptors.response.use(interceptorResponseSuccess, interceptorResponseError)
axiosInstance.interceptors.request.use(interceptorRequest, interceptorRequestError)

const Get = (url, params, config) => {
	return axiosInstance.get(url, addParams(params, config))
}

const Delete = (url, params) => {
	return axiosInstance.delete(url, { params })
}

const Post = (url, data, headers) => {
	return axiosInstance.post(url, data, headers)
}

const Put = (url, data) => {
	return axiosInstance.put(url, data)
}

const addParams = (params, config) => {
	return Object.assign({}, { params }, config)
}

export { Post, Get, Put, Delete }
